/**
 * Random variables used in the app
 */
export const LOGIN_ROUTE_PATH = 'login'
export const HOME_ROUTE_PATH = 'admin'
export const ADMIN_ROLE = 'fotoAdmin'
export const USER_ROLE = 'fotoUser'